import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/modulos',
    component: () => import('../views/Modulos'),
    meta: {
      title: 'Módulos',
    }
  },
  {
    path: '/modulos/',
    name: 'modulos',
    component: () => import('../views/Modulos'),
    meta: {
      title: 'Módulos',
    }
  },
  {
    path: "/usuario",
    component: () =>
        import(/* webpackChunkName: "usuario" */ "@/views/usuario/UsuarioLista.vue"),
    meta: {
      title: 'Usuários',
    }
  },
  {
    path: "/usuario/form",
    name: "usuarioForm",
    component: () =>
        import(/* webpackChunkName: "usuario" */ "@/views/usuario/UsuarioForm.vue")
  },
  {
    path: "/cadastro/form/:id",
    name: "usuarioFormId",
    props: true,
    component: () =>
        import(/* webpackChunkName: "usuario" */ "@/views/usuario/UsuarioForm.vue")
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '',
  routes
})

export default router
